import '../numeric_filter_view.js.coffee'

Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.FollowersCountFilterView extends Monitoring.Views.SocialContents.Filters.NumericFilterView
  fieldName: 'followers'

  initialize: ({searchQuery}) ->
    super(
      searchQuery: searchQuery
      title: I18n.t('monitoring.dashboard.filters.filter_names.followers_count')
    )

  _isValid: (min, max) ->
    (0 <= min && min <= 999999) && (0 <= max && max <= 999999)
